
    import Component from "vue-class-component";
    import {Prop} from "vue-property-decorator";
    import {
        ApplicationActions,
        EditDocumentSeedRequest,
        EditSeniorMaritimePilotCertificateSeedRequest,
        ResultError,
        AreasClient
    } from "@/api-client";
    import IssueDocumentInnerComponent from "@/features/applications/components/issue-document/IssueDocumentInnerComponent";
    import IssueDocumentSignature from "@/features/applications/components/issue-document/IssueDocumentSignature.vue";
    import DatePicker from "@/components/DatePicker.vue";
    import LabelOptional from "@/features/shared/components/LabelOptional.vue";
    import AdditionalInfoButton from "@/features/shared/components/AdditionalInfoButton.vue";
    import Multiselect from "vue-multiselect";

    @Component({
        components: {
            AdditionalInfoButton,
            DatePicker,
            IssueDocumentSignature,
            LabelOptional,
            Multiselect
        }
    })
    export default class IssueSeniorMaritimePilotCertificate extends IssueDocumentInnerComponent {
        @Prop({required: true})
        issueDocumentDetails!: any;
        @Prop({required: true})
        actions!: ApplicationActions;
        @Prop({required: true})
        errors!: ResultError;

        initialEditModel!: EditDocumentSeedRequest;
        areasClient = new AreasClient();

        validUntil = this.issueDocumentDetails.validUntil;
        issueDate = this.issueDocumentDetails.issueDate;
        additionalInfo = this.issueDocumentDetails.additionalInfo;
        // No validation for GT fields in Senior Maritime Pilot Certificate
        shipGrossTonnage: number | null = this.issueDocumentDetails.shipGrossTonnage || null;
        tankerGrossTonnage: number | null = this.issueDocumentDetails.tankerGrossTonnage || null;
        selectedPilotageAreas: any[] = [];
        pilotageAreaOptions: any[] = [];

        async mounted() {
            await this.loadPilotageAreas();
            // Initialize selected areas from existing data after options are loaded
            if (this.issueDocumentDetails.pilotageAreaIds && this.issueDocumentDetails.pilotageAreaIds.length > 0) {
                this.selectedPilotageAreas = this.pilotageAreaOptions.filter(option =>
                    this.issueDocumentDetails.pilotageAreaIds.includes(option.id)
                );
            }
            this.initialEditModel = this.getEditModel();
        }

        async loadPilotageAreas() {
            const areasClient = new AreasClient();
            const response = await areasClient.areaOptions();

            // Map the areas to the format expected by the multiselect
            this.pilotageAreaOptions = response.areas
                .map(area => ({
                    id: area.value,
                    name: area.text
                }));
        }

        getEditModel(): EditDocumentSeedRequest {
            const request = new EditSeniorMaritimePilotCertificateSeedRequest();
            request.additionalInfo = this.additionalInfo;
            request.issueDate = this.issueDate;
            request.validUntil = this.validUntil;
            request.shipGrossTonnage = this.shipGrossTonnage;
            request.tankerGrossTonnage = this.tankerGrossTonnage;
            // Extract just the IDs from the selected areas
            request.pilotageAreaIds = this.selectedPilotageAreas.map(area => area.id);
            return request;
        }
    }
